// Dependencies
import * as React from 'react';
// Styled
import { SvgElement } from './IconStyle';
// Props
import { IconProps, defaultProps } from './IconProps';

const Link = (props:IconProps) => {
  const componentProps = { ...defaultProps, ...props };
  const {
    fillColor,
    height,
    onClick,
    width,
  } = componentProps;

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <SvgElement
      height={ height }
      onClick={ handleClick }
      preserveAspectRatio="none"
      viewBox="0 0 20 20"
      width={ width }
    >
      <g transform="translate(322 208.422)">
        <path
          d="
            M-302.0002747-198.4244537
            c-0.0038147-0.9677887-0.395752-1.8936005-1.0879822-2.5699615
            c-0.8036194-0.7887268-1.8869629-1.2270355-3.01297-1.2189789
            l-4.1869202,0.0240021
            c-1.8455811-0.0411224-3.4842529,1.173996-3.980957,2.9519501
            c-0.0594482,0.2714233-0.0955811,0.5474243-0.1080017,0.8249969
            c-0.0022278,0.2741852,0.0314026,0.5475006,0.1000061,0.8129883
            l0.0359802,0.1549988h0.5499878
            c0.3118286-0.0031738,0.6156616-0.098877,0.8730164-0.2749939
            c0.2444458-0.1542511,0.3999329-0.4165039,0.4179688-0.7050018
            c0.0980835-1.0897369,1.0482788-1.901825,2.1399841-1.8289642
            h4.2079468
            c0.6054688-0.0058289,1.1891174,0.225708,1.6259766,0.644989
            c0.3227539,0.3096466,0.5078735,0.7357483,0.5139771,1.1829834
            c0.0032959,0.483139-0.1859741,0.9477081-0.5259705,1.2909851
            c-0.3389282,0.3465576-0.8063965,0.5370178-1.2909851,0.5259857
            l-3.4589539,0.0130005l-0.0599976,0.1080017
            c-0.2884216,0.5725555-0.6898193,1.08078-1.1799927,1.4939728
            l-0.4179993,0.3470001
            h5.0449524
            c1.0015869,0.0007629,1.9617615-0.3997345,2.6659546-1.1119843
            C-302.3995972-196.4485016-301.9877319-197.4159088-302.0002747-198.4244537z
          "
          fill={ fillColor }
        />
        <path
          d="
            M-320.9240112-195.8544769L-320.9240112-195.8544769
            c0.8029785,0.7901917,1.8863831,1.2299652,3.01297,1.2229767
            h4.1839294
            c1.8455505,0.0411072,3.4842529-1.1740112,3.9809265-2.9519653
            c0.0594788-0.2714081,0.0956116-0.5474091,0.1080017-0.8249817
            c0.0022278-0.2742004-0.0314026-0.5475006-0.0999756-0.8129883
            l-0.0320129-0.1600037h-0.5499878
            c-0.3118286,0.0031738-0.6156616,0.098877-0.8729858,0.2749939
            c-0.2444763,0.1542511-0.3999634,0.4165039-0.4179993,0.7050018
            c-0.0980835,1.0897369-1.0482483,1.901825-2.1399841,1.8289642
            l-4.171936-0.0110016
            c-0.605896,0.0050201-1.1896057-0.2276001-1.6259766-0.6479797
            c-0.3227539-0.3096466-0.5078735-0.7357635-0.5139771-1.1829834
            c-0.0032959-0.4831543,0.1859741-0.9477081,0.5259705-1.2909851
            c0.3389282-0.3465576,0.8063965-0.5370331,1.2909851-0.526001
            h3.3999634l0.0599976-0.1079865
            c0.2872009-0.5722046,0.6880188-1.0798645,1.1779785-1.4919891
            l0.4190063-0.3469849
            l-5.0329285-0.0120087
            c-2.0848999,0.0038605-3.7741089,1.6930389-3.7779541,3.7779541
            C-322.0005188-197.4496765-321.6125793-196.5274048-320.9240112-195.8544769z
          "
          fill={ fillColor }
        />
      </g>
    </SvgElement>
  );
};

export { Link };
